import React, { FC } from 'react'
import styled from 'styled-components'
import { Text } from 'ui'
import { Step4Props } from './types'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 24px;
    height: 100%;
    overflow-y: auto;
    
    /* Hide scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`

const Step4: FC<Step4Props> = ({ agreementDetails }) => {
    return (
        <Container>
            {agreementDetails.map((detail, index) => (
                <Text key={index} size="sm" weight="normal" style={{ color: '#272727' }}>
                    {index + 1}. {detail}
                </Text>
            ))}
        </Container>
    )
}

export default Step4
